// extracted by mini-css-extract-plugin
export default {"requiredFieldLabel":"RequiredIndicator_requiredFieldLabel__pxRR3"};